import React from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";

const Popup = (props) => {
  return (
    <PopupContainer
      style={{
        ...props.style,
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <PopupHeader>
        <PopupHeaderText>{props.headerTitle}</PopupHeaderText>
        <img
          src="/assets/admin/icons/ico_popup_close.svg"
          alt="팝업 닫기"
          style={{
            width: 30,
            height: 30,
            cursor: "pointer",
          }}
          onClick={props.onClick}
        />
      </PopupHeader>
      {props.children}
      {!props.noFooter && (
        <PopupFooter>
          {!props.noFooterBtn && (
            <PopupFooterBtn onClick={props.footerBtnHandler}>
              <PopupFooterText>{props.footerBtnText}</PopupFooterText>
            </PopupFooterBtn>
          )}
        </PopupFooter>
      )}
    </PopupContainer>
  );
};

export default Popup;

const PopupContainer = styled.div.attrs((props) => {})`
  width: 632px;
  height: fit-content;
  padding: 20px 0px;
  background-color: #272829;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;
`;

const PopupHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 54px;
  padding: 0px 30px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const PopupHeaderText = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 20px;
  line-height: 34px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const PopupFooter = styled.div.attrs((props) => {})`
  width: 100%;
  height: 69px;
  padding: 0px 30px;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const PopupFooterBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #272829;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  &:hover {
    background-color: inherit;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

const PopupFooterText = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 15px;
  line-height: 24.5px;
  color: #aaa;
`;
